import { Box, Typography } from "@mui/material";

export default function NoSelectionDetailsScreen() {
    return (
        <Box sx={{ height: '100%', p:5, gap: '1rem', flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', textAlign: 'center' }}>
            <Typography variant="h2" component="h1" gutterBottom>
                Welcome!
            </Typography>
            <Typography variant="body1">
                Use the radio buttons to the left to select a type of search to perform. 
                Then, type your search query in the chat box below.
            </Typography>
            <Typography variant="body1">
                Or, use one of the example prompts to get started.
            </Typography>
            <Typography variant="body1">
                This panel will display the details of the selected material/product while you search
            </Typography>
        </Box>
    );
}
